import { useTranslation } from 'react-i18next'

import {
  useDateLocale,
  useNotification,
  useTimeZone,
} from '../../../../../hooks'
import {
  getMockCalendarDayLoad,
  moveMockCalendarFollowUps,
} from '../../../Calendar.mock'
import { formatCalendarDate } from '../../../Calendar.utils'
import { CalendarFollowUpCapModal } from '../../../CalendarFollowUpCapModal'

import { getCalendarViewFollowUpUncheckedMoveText } from './useCalendarViewFollowUpMove.utils'

export function useCalendarViewFollowUpMove({
  getActionToken,
  setModal,
  onClose,
  onReload,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const {
    handleAddErrorNotification,
    handleAddSuccessNotification,
    handleAddWarningNotification,
  } = useNotification()

  // TODO: write the due date through the request's due date update once the
  // backend returns the target day's load with it.
  async function moveFollowUp({ date, item }) {
    return moveMockCalendarFollowUps({
      date,
      ids: [item.id],
      sourceDate: item.date,
      timezone,
    })
  }

  function handleFollowUpMoved(date) {
    onReload()

    handleAddSuccessNotification({
      title: t('Calendar.FollowUpMovedToastKey', {
        date: formatCalendarDate({ date, locale }),
      }),
    })
  }

  async function handleMoveFollowUpTo({ date, item }) {
    return moveFollowUp({ date, item })
      .then(() => {
        handleFollowUpMoved(date)
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  async function handleMoveFollowUpFromCap({ date, item }) {
    const actionToken = getActionToken()

    return moveFollowUp({ date, item })
      .then(() => {
        if (getActionToken() === actionToken) {
          onClose()
        }

        handleFollowUpMoved(date)
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  async function handleMoveFollowUpUnchecked({ date, item }) {
    return moveFollowUp({ date, item })
      .then(({ data }) => {
        onReload()

        handleAddWarningNotification({
          text: getCalendarViewFollowUpUncheckedMoveText({
            dayLoad: data.day_load,
            locale,
            t,
          }),
          title: t('Calendar.FollowUpMovedToastKey', {
            date: formatCalendarDate({ date, locale }),
          }),
        })
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  async function handleMoveFollowUp({ date, item }) {
    const actionToken = getActionToken()

    // TODO: read the target day's load from the day-load endpoint once the
    // backend serves it.
    return getMockCalendarDayLoad({ date, timezone }).then(
      ({ data }) => {
        if (!data.is_full) {
          handleMoveFollowUpTo({ date, item })
        } else if (getActionToken() === actionToken) {
          setModal(
            <CalendarFollowUpCapModal
              dayLoad={data}
              item={item}
              onClose={onClose}
              onMove={handleMoveFollowUpFromCap}
            />
          )
        }
      },
      () => {
        handleMoveFollowUpUnchecked({ date, item })
      }
    )
  }

  return { handleMoveFollowUp }
}
